<template>
  <!-- Header -->
  <div class="header pork">
    <div class="container">
      <router-link class="site-logo" to="/Pork/English/PTCInfo">
        <img src="@/assets/image/pork_logo.png" alt="Pork to China" height="40">
        <h5 class="sub-text">Your best explorer in the Chinese pork market</h5>
      </router-link>
      <!-- Navigation -->
      <div class="header-navigation pull-right font-transform-inherit">
        <ul class="nav-list">
          <li>
            <router-link to="/Pork/English/PTCInfo" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">PTC Info</router-link>
            <!-- <ul class="dropdown-menu">
              <li><router-link :to="{ path: '/Pork/English/PorkSection', query: { sectionid: '_porknews_en', sectiontitle: 'PTC Express' }}">PTC Express</router-link></li>
              <li><router-link :to="{ path: '/Pork/English/PorkSection', query: { sectionid: '_porkanalysis_en', sectiontitle: 'PTC Analysis' }}">PTC Analysis</router-link></li>
            </ul> -->
          </li>
          <!-- BTC Data -->
          <li>
            <a class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">PTC Data</a>
            <ul class="dropdown-menu">
              <li><router-link to="/Pork/English/PTCData/PorkExportToChina">Global Pork Exports to China</router-link></li>
              <li><router-link to="/Pork/English/PTCData/GlobalPorkExports">Global Pork Exports</router-link></li>
              <li><router-link to="/Pork/English/PTCData/ChinaPorkImports">China's Pork Imports</router-link></li>
            </ul>
          </li>
          <li>
            <router-link to="/Pork/English/PTCEst" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">PTC Est.</router-link>
          </li>
          <!-- Beef -->
          <li>
            <router-link style="height: 84px; padding: 17px 12px;" to="/english/BTCInfo" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;"><img src="@/assets/image/btc_btn_en.png" height="40px;"></router-link>
          </li>
          <!-- Search -->
          <li class="menu-search">
            <span class="sep"/>
            <i class="fa fa-search search-btn" @click="handelClick"/>
            <div :class="{ showSearchBox: showSearch }" class="search-box">
              <form>
                <div class="input-group col-xs-5 pull-left" style="padding-right: 10px;">
                  <select v-model="country" type="text" class="form-control">
                    <option value="" label="All Countries"/>
                    <option v-for="item in countryOptions" :key="item.value" :value="item">{{ $t(`message['${item}']`) }}</option>
                    <option value="_other" label="Other"/>
                  </select>
                </div>
                <div class="input-group col-xs-7 pull-left">
                  <input v-model="keyWords" type="text" placeholder="Please Input Keyword" class="form-control">
                  <span class="input-group-btn">
                    <button class="btn btn-primary" style="background: #ff8888;" @click.prevent="handleSearch">Search</button>
                  </span>
                </div>
              </form>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { porkcountrydata } from '@/utils/dictionary'
export default {
  name: 'Header',
  data() {
    return {
      country: '',
      keyWords: '',
      showSearch: false,
      countryOptions: porkcountrydata
    }
  },
  computed: {
    isPork() {
      return this.$route.path.includes('Pork') || this.$route.path.includes('PTC')
    },
    path() {
      if (this.isPork) {
        return '/Pork/English/PorkSearch'
      } else {
        return '/english/search'
      }
    }
  },
  created() {
    window.addEventListener('mouseup', this.handleMouseup)
  },
  methods: {
    handelClick() {
      this.showSearch = !this.showSearch
      return this.showSearch
    },
    handleMouseup(event) {
      if (this.showSearch && (event.target.nodeName !== 'INPUT' && event.target.nodeName !== 'SELECT')) {
        this.showSearch = false
      }
    },
    handleSearch() {
      if (this.country || this.keyWords) {
        this.$router.push({ path: this.path, query: { keywords: this.keyWords, country: this.country }})
      }
      this.keyWords = ''
      this.country = ''
    }
  }
}
</script>

<style>
.pork .header-navigation .dropdown-menu > li > a:hover {
  background: #ff8888!important;
}
.pork .header-navigation .dropdown-menu > li:first-child {
  border-top: 2px solid #ff8888!important;
}
</style>

<style scoped>
.header { margin-bottom: 8px!important; }
a { text-decoration: none; padding: 14px }
.site-logo { margin: 0 }
.site-logo:link    { color: #ff8888 }
.site-logo:visited { color: #ff8888 }
.site-logo:hover   { color: #ff8888 }
.site-logo:active  { color: #ff8888 }
.sub-text { font-size: 13px; margin: 2px 0 0 0 }
.nav-list { font-size: 19px; }
.showSearchBox { display: inline!important }
.mobi-toggler { margin-left: 1px;}
</style>



// WEBPACK FOOTER //
// src/views/layout_pork_en/components/Navigation/index.vue